import { render } from "./OffersSummary.vue?vue&type=template&id=9adfa7ac&scoped=true"
import script from "./OffersSummary.vue?vue&type=script&lang=js"
export * from "./OffersSummary.vue?vue&type=script&lang=js"

import "./OffersSummary.vue?vue&type=style&index=0&id=9adfa7ac&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9adfa7ac"]])

export default __exports__